import { InitialVehicleType, VehicleTypes } from './types';
export const getVehicleType = (payload: InitialVehicleType) => {
  return {
    type: VehicleTypes.GET_VEHICLE_TYPE,
    payload,
  };
};

export const ClearVehicleType = () => {
  return {
    type: VehicleTypes.CLEAR_VEHICLE_TYPE,
  };
};
